<template>
  <router-view />
</template>

<script>
export default {
  name: "LHP",
};
</script>
